import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import React from 'react';

interface CustomFieldLabelProps {
  customField: string; // Label for the custom field
  fieldValue: string; // Value of the custom field
  fieldValueBgColor?: string; // Background color for the value box
  fieldValueTextColor?: string; // Text color for the value box
  hideCustomFieldLabel?: boolean;
  enableTruncate?: boolean;
}

const CustomFieldLabel: React.FC<CustomFieldLabelProps> = ({
  customField,
  fieldValue,
  fieldValueBgColor = 'green.100', // Default background color
  fieldValueTextColor = 'gray.800', // Default text color
  hideCustomFieldLabel = true,
  enableTruncate = true,
}) => {
  const valueText = (
    <Text
      color={fieldValueTextColor}
      fontSize="0.75rem"
      fontWeight="500"
      lineHeight="1rem"
      isTruncated={enableTruncate}
      maxWidth={enableTruncate ? '15rem' : 'none'}
      whiteSpace={enableTruncate ? 'nowrap' : 'normal'}
      overflow={enableTruncate ? 'hidden' : 'visible'}
      textOverflow={enableTruncate ? 'ellipsis' : 'unset'}
    >
      {fieldValue}
    </Text>
  );

  return (
    <Flex alignItems="center" gap="0.5rem">
      {hideCustomFieldLabel && (
        <Text
          color="gray.600"
          fontSize="0.75rem"
          fontWeight="700"
          lineHeight="1.125rem"
        >
          {customField}
        </Text>
      )}
      <Box
        display="flex"
        alignItems="center"
        gap="0.375rem"
        minH="1.5rem"
        px="0.625rem"
        py="0.25rem"
        borderRadius="0.375rem"
        bg={fieldValueBgColor}
      >
        {enableTruncate ? (
          <Tooltip label={fieldValue}>{valueText}</Tooltip>
        ) : (
          valueText
        )}
      </Box>
    </Flex>
  );
};

export default CustomFieldLabel;
